import { render, staticRenderFns } from "./AnnualTaxPaymentSubTable.vue?vue&type=template&id=0a5336a6&"
import script from "./AnnualTaxPaymentSubTable.vue?vue&type=script&lang=js&"
export * from "./AnnualTaxPaymentSubTable.vue?vue&type=script&lang=js&"
import style0 from "./AnnualTaxPaymentSubTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports